export default __webpack_public_path__ + "static/grundfos-bg-0e35c84c95a614bedc5e4647bd64ffac.png";